export const ACTIONS = {
  fit: {
    title: "Fit Tyre", endpoint: "/fitments", needsSite: true,
    fields: [
      { name: "size", label: "Tyre Size", type: "select", optionsKey: "tyre_sizes", required: true },
      { name: "axles", label: "Number of Axles (truck)", type: "select", options: [{ value: "3", label: "3 Axles (10 tyres)" }, { value: "4", label: "4 Axles (12 tyres)" }], required: true, showIfTruckSize: true },
      { name: "serial_number", label: "Tyre Serial Number", type: "text", required: true },
      { name: "dumper_number", label: "Dumper Number", type: "text", required: true },
      { name: "position", label: "Position", type: "select", optionsKey: "positions", required: true },
      { name: "performed_date", label: "Date it happened", type: "date", half: true },
      { name: "engine_hours", label: "Fitment Engine Hours (blank = estimate from date)", type: "number", half: true },
      { name: "vehicle_km", label: "Fitment KM", type: "number", required: true, half: true },
      { name: "make", label: "Vehicle Make", type: "text", required: true, showIfMakeModel: true, half: true },
      { name: "model", label: "Vehicle Model", type: "text", required: true, showIfMakeModel: true, half: true },
      { name: "condition", label: "Tyre Condition", type: "select", optionsKey: "fit_conditions", required: true },
      { name: "repair_type", label: "Type of Repair", type: "select", optionsKey: "repair_types", required: true, showIf: { field: "condition", value: "Repaired" } },
      { name: "repair_count", label: "No. of Times Repaired", type: "number", required: true, showIf: { field: "condition", value: "Repaired" } },
      { name: "pressure", label: "Pressure (psi)", type: "number" },
      { name: "purchase_cost", label: "Tyre Cost (₹) — blank = default for size", type: "number", showIf: { field: "condition", value: "New" } },
      { name: "pressure_checked", label: "Tyre pressure checked", type: "checkbox", half: true },
      { name: "rim_cleaned", label: "Rim cleaned", type: "checkbox", half: true },
      { name: "rim_hole_checked", label: "Rim hole size checked (no difference)", type: "checkbox", half: true },
      { name: "powder_applied", label: "Powder applied before fitment", type: "checkbox", half: true },
      { name: "photos", label: "Photos", type: "photos" },
    ],
  },
  remove: {
    title: "Remove Tyre", endpoint: "/removals",
    fields: [
      { name: "tyre_id", label: "Tyre (currently fitted)", type: "tyre", required: true, tyreFilter: (t) => t.status === "Fitted" },
      { name: "performed_date", label: "Date it happened", type: "date", half: true },
      { name: "engine_hours", label: "Engine Hrs at Removal (blank = estimate)", type: "number", half: true },
      { name: "tread_depth", label: "Tread Depth (mm)", type: "number", half: true },
      { name: "reason", label: "Reason for Removal", type: "select", optionsKey: "removal_reasons", required: true, half: true },
      { name: "condition", label: "Tyre Condition", type: "select", optionsKey: "conditions", half: true },
      { name: "remarks", label: "Remarks", type: "textarea" },
      { name: "photos", label: "Photos", type: "photos" },
    ],
  },
  inspect: {
    title: "Tyre Inspection", endpoint: "/inspections",
    fields: [
      { name: "tyre_id", label: "Tyre", type: "tyre", required: true },
      { name: "performed_date", label: "Date it happened", type: "date", half: true },
      { name: "engine_hours", label: "Current Engine Hours", type: "number", required: true, half: true },
      { name: "vehicle_km", label: "Current Vehicle KM", type: "number", required: true, half: true },
      { name: "tread_depth", label: "Tread Depth (mm)", type: "number", half: true },
      { name: "pressure", label: "Pressure (psi)", type: "number", half: true },
      { name: "shoulder_condition", label: "Shoulder", type: "select", optionsKey: "conditions", half: true },
      { name: "sidewall_condition", label: "Sidewall", type: "select", optionsKey: "conditions", half: true },
      { name: "tread_condition", label: "Tread", type: "select", optionsKey: "conditions", half: true },
      { name: "cuts", label: "Cuts", type: "checkbox", half: true },
      { name: "cracks", label: "Cracks", type: "checkbox", half: true },
      { name: "bulges", label: "Bulges", type: "checkbox", half: true },
      { name: "irregular_wear", label: "Irregular Wear", type: "checkbox", half: true },
      { name: "stone_trapping", label: "Stone Trapping", type: "checkbox", half: true },
      { name: "recommended_action", label: "Recommended Action", type: "select", optionsKey: "inspection_actions", required: true },
      { name: "photos", label: "Photos", type: "photos" },
    ],
  },
  pressure: {
    title: "Pressure Check", endpoint: "/pressure-checks",
    fields: [
      { name: "tyre_id", label: "Tyre", type: "tyre", required: true },
      { name: "recommended_pressure", label: "Recommended (psi)", type: "number", half: true },
      { name: "actual_pressure", label: "Actual (psi)", type: "number", required: true, half: true },
    ],
  },
  puncture: {
    title: "Puncture / Damage Report", endpoint: "/punctures",
    fields: [
      { name: "tyre_id", label: "Tyre", type: "tyre", required: true },
      { name: "engine_hours", label: "Engine Hours", type: "number", half: true },
      { name: "vehicle_km", label: "Current Vehicle KM", type: "number", half: true },
      { name: "puncture_type", label: "Puncture / Damage Type", type: "select", optionsKey: "puncture_categories", required: true, half: true },
      { name: "object", label: "Object Causing Puncture", type: "text", half: true },
      { name: "injury_location", label: "Injury Location on Tyre", type: "text", half: true },
      { name: "repaired", label: "Tyre was repaired (uncheck = replaced)", type: "checkbox" },
      { name: "damage_description", label: "Damage Description", type: "textarea" },
      { name: "remarks", label: "Remarks", type: "textarea" },
      { name: "photos_before", label: "Photos Before Repair", type: "photos" },
      { name: "photos_after", label: "Photos After Repair", type: "photos" },
    ],
  },
};
